export const BookDescription = ({ description }) => <p>{description}</p>
